import React from "react";
import { FormattedMessage } from "react-intl";
import RankingTooltipsContainer from "../RankingTooltips/RankingTooltipContainer";
import RankingCell from "./RankingCell.jsx";
const RankingTable = ({
  entries,
  columns,
  onDetailsClick,
  onTeamClick,
  game,
  userEntries,
  markedTeams,
  markedClassificationTeams,
}) => {
  if (!entries) {
    return null;
  }
  return (
    <table className="zw-tbl my-results-tbl">
      <TableHeader columns={columns} />
      <tbody>
        {entries.map((entry, i) => (
          <TableRow
            key={i}
            marked={markedTeams.includes(entry.zweelerTeamId)}
            markedTeam={
              markedClassificationTeams
                ? markedClassificationTeams.includes(
                    entry.zweelerTeamId.toString()
                  )
                : false
            }
            game={game}
            entry={entry}
            columns={columns}
            onDetailsClick={onDetailsClick}
            onTeamClick={onTeamClick}
          />
        ))}
      </tbody>
      <UserTableSeparator entries={userEntries} />
      <UserTableHeader entries={userEntries} columns={columns} />
      <UserTable
        entries={userEntries}
        columns={columns}
        onTeamClick={onTeamClick}
        onDetailsClick={onDetailsClick}
        game={game}
      />
    </table>
  );
};

const UserTableSeparator = ({ entries }) => {
  if (!entries || !entries.length) {
    return null;
  }
  return (
    <tbody>
      <tr>
        <td colSpan="1000" className="ranking-table__table-separator user-teams">
          <FormattedMessage id="ranking.yourTeams" />
        </td>
      </tr>
    </tbody>
  );
};
const UserTableHeader = ({ entries, columns }) => {
  if (!entries || !entries.length) {
    return null;
  }
  return <TableHeader columns={columns} />;
};
const UserTable = ({ entries, columns, onDetailsClick, onTeamClick, game }) => {
  if (!entries || !entries.length) {
    return null;
  }
  return (
    <tbody>
      {entries.map((entry, i) => (
        <TableRow
          key={i}
          game={game}
          entry={entry}
          columns={columns}
          onDetailsClick={onDetailsClick}
          onTeamClick={onTeamClick}
        />
      ))}
    </tbody>
  );
};

const TableHeader = ({ columns }) => (
  <thead>
    <tr>
      {columns.map((col, i) => (
        <TableHeaderCell key={i} column={col} />
      ))}
    </tr>
  </thead>
);

const TableHeaderCell = ({ column }) => {
  let header;
  if (column.abbr) {
    header = <abbr title={column.name}>{column.abbr}</abbr>;
  } else {
    header = column.name;
  }

  if (column.type === "teamName") {
    return (
      <th>
        <RankingTooltipsContainer id="teams">{header}</RankingTooltipsContainer>
      </th>
    );
  }
  if (
    column.type === "pointsTotal" ||
    column.type === "pointsWithPreviousLinked"
  ) {
    return (
      <th>
        <RankingTooltipsContainer id="points">
          {header}
        </RankingTooltipsContainer>
      </th>
    );
  }

  return <th>{header}</th>;
};

class TableRow extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleDetailsClick = this.handleDetailsClick.bind(this);
    this.handleTeamClick = this.handleTeamClick.bind(this);
  }

  handleDetailsClick() {
    this.props.onDetailsClick(this.props.entry.zweelerTeamId);
  }

  handleTeamClick() {
    this.props.onTeamClick(this.props.entry.zweelerTeamId);
  }

  render() {
    return (
      <tr
        className={
          "ranking-entry " + (this.props.marked ? " ranking-entry--marked" : "") + (this.props.entry.ranked ? " ranking-entry--ranked": " ranking-entry--unranked")
        }
      >
        {this.props.columns.map((col, i) => (
          <RankingCell
            key={i}
            game={this.props.game}
            entry={this.props.entry}
            column={col}
            onDetailsClick={this.handleDetailsClick}
            ticketImg={this.props.game.ticketImg}
            marked={this.props.markedTeam}
          />
        ))}
      </tr>
    );
  }
}

RankingTable.propTypes = {};

export default RankingTable;
